import React from "react";
import { Link } from "react-router-dom";
import Logo from "../Logo.png"; // Adjust the path as needed

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200 py-8 px-10 md:px-20">
      <div className="flex flex-col md:flex-row justify-between items-center">
        {/* Logo & Copyright */}
        <div className="flex items-center space-x-4">
          <img src={Logo} alt="Logo" className="h-10 w-auto" />
          <span className="text-gray-600 text-sm font-medium">
            © {new Date().getFullYear()} 3e Solar Ventures. All rights reserved.
          </span>
        </div>

        {/* Navigation Links */}
        <ul className="flex space-x-6 mt-4 md:mt-0">
          <li>
            <Link to="/" className="text-gray-600 hover:text-gray-900 transition text-sm">
              Home
            </Link>
          </li>
          <li>
            <Link to="/services" className="text-gray-600 hover:text-gray-900 transition text-sm">
              Services
            </Link>
          </li>
          <li>
            <Link to="/blogs" className="text-gray-600 hover:text-gray-900 transition text-sm">
              Blog/Resources
            </Link>
          </li>
          <li>
            <Link to="/contact" className="text-gray-600 hover:text-gray-900 transition text-sm">
              Contact
            </Link>
          </li>
        </ul>
      </div>

      {/* Social Media & Footer Note */}
      <div className="mt-6 flex flex-col md:flex-row justify-between items-center">
        <div className="flex space-x-4">
          {/* Example social icons; you can replace with your preferred icons */}
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-gray-900 transition">
            <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24">
              <path d="M22.675 0h-21.35C.595 0 0 .594 0 1.326v21.348C0 23.406.595 24 1.325 24H12.82v-9.294H9.692v-3.622h3.127V8.413c0-3.1 1.894-4.788 4.659-4.788 1.325 0 2.464.099 2.794.143v3.24l-1.918.001c-1.504 0-1.796.715-1.796 1.762v2.311h3.587l-.467 3.622h-3.12V24h6.116C23.405 24 24 23.406 24 22.674V1.326C24 .594 23.405 0 22.675 0z"/>
            </svg>
          </a>
          <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-gray-900 transition">
            <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24">
              <path d="M24 4.557a9.83 9.83 0 01-2.828.775 4.932 4.932 0 002.165-2.724c-.951.564-2.005.974-3.127 1.195A4.916 4.916 0 0016.616 3c-2.723 0-4.932 2.21-4.932 4.932 0 .386.043.762.127 1.124C7.728 8.87 4.1 6.865 1.67 3.149a4.902 4.902 0 00-.666 2.479c0 1.71.87 3.213 2.188 4.096a4.903 4.903 0 01-2.23-.616v.062c0 2.385 1.697 4.374 3.946 4.827a4.935 4.935 0 01-2.224.084 4.935 4.935 0 004.604 3.417A9.868 9.868 0 010 19.54a13.94 13.94 0 007.548 2.209c9.058 0 14.01-7.514 14.01-14.01 0-.213-.005-.425-.015-.637A10.025 10.025 0 0024 4.557z"/>
            </svg>
          </a>
          {/* Add more social icons if needed */}
        </div>
        <p className="mt-4 md:mt-0 text-gray-500 text-xs">
          Designed with love by Shashank Dewangan
        </p>
      </div>
    </footer>
  );
};

export default Footer;
